module.exports = __webpack_public_path__ + "static/media/phpicon.fe68ea80.svg";